import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';

import { ProgramLookupComponent } from './program-lookup.component';
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    NgSelectModule
  ],
  declarations: [ProgramLookupComponent],
  exports: [ProgramLookupComponent],
  providers: []
})
export class ProgramLookupModule { }
